import React from "react";
import { List, ListItem, Card, Icon } from "react-onsenui";
import { getSubstanceById } from "../../services/substances";
import SubstanceInfoBasic from "./SubstanceInfoBasic";
import SubstanceInfoDosage from "./SubstanceInfoDosage";
import SubstanceInfoWarnings from "./SubstanceInfoWarnings";
import LearnMoreContent from "../popup/LearnMoreContent";
import SubstanceMegamix from "./SubstanceMegamix";
import SubstanceIdentification from "./SubstanceIdentification";

export default class SubstanceInfo extends React.Component {
  state = {
    info: null,
    error: null,
    showModal: false,  // State to handle modal visibility
  };

  openLearnMoreModal = () => {
    this.setState({ showModal: true });
  };

  closeLearnMoreModal = () => {
    this.setState({ showModal: false });
  };

  componentDidMount() {
    const { substance } = this.props;

    // Dodajemy log do konsoli, żeby zobaczyć, co jest przekazywane w propsach
    // console.log("SubstanceInfo props:", this.props);
    // console.log("Substance:", substance);

    // Sprawdzamy, czy substance i sid są zdefiniowane
    if (substance && substance.sid !== null && substance.sid !== undefined) {
      // console.log("Valid substance, fetching info by SID:", substance.sid);
      const info = getSubstanceById(substance.sid);
      if (info) {
        this.setState({ info });
        // console.log("Fetched info:", info);
      } else {
        this.setState({ error: "Substance not found" });
        // console.error("Substance not found for SID:", substance.sid);
      }
    } else {
      this.setState({ error: "Invalid substance data" });
      // console.error("Invalid substance data:", substance);
    }
  }

  render() {
    const { error, info, showModal } = this.state;
    const { substance } = this.props;

    // Logujemy błąd do konsoli
    if (error) {
      console.error("Substance Information Error:", error);
      return <div>Error: {error}</div>;
    }

    if (!info) {
      return <div>Loading substance information...</div>;
    }

    return (
      <Card class="simplified-list" style={{ padding: "15px 20px 10px 20px" }}>
        <SubstanceInfoBasic substance={substance} info={info} />
        <SubstanceInfoWarnings substance={substance} info={info} />
        <SubstanceInfoDosage substance={substance} info={info} />
        <SubstanceIdentification substance={substance} />
        <SubstanceMegamix substance={substance} />

       
        <div style={{ margin: "20px 0px 10px 0px", padding: "0px 20px 0px 20px", textAlign: "center", fontSize: "0.8em" }}>
          <div onClick={this.openLearnMoreModal} style={{ cursor: "pointer", fontWeight: "bold" }}>
          {/*   About DrugsPRO          */}

          </div>
        </div>
 {/* 
        {showModal && (
          <div style={modalStyles.modalOverlay}>
            <div style={modalStyles.modalContent}>
              <LearnMoreContent onClose={this.closeLearnMoreModal} />
            </div>
          </div>
        )}
        */}
      </Card>
    );
  }
}

const modalStyles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    maxWidth: "600px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    width: "80%",
    overflowY: "auto",  // Dodano obsługę scrolla
    // maxHeight: "400px",  
  }
};